(() => {
  document.documentElement.classList.remove('no-js');
  const rootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format((Number(cents) || 0) / 100);

  function setGallery(root, index) {
    const images = root.querySelectorAll('[data-gallery-image]');
    const buttons = root.querySelectorAll('[data-gallery-button]');
    images.forEach((image, i) => image.classList.toggle('is-hidden', i !== Number(index)));
    buttons.forEach((button, i) => { button.classList.toggle('is-active', i === Number(index)); button.setAttribute('aria-current', i === Number(index) ? 'true' : 'false'); });
  }

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const root = gallery.closest('[data-product-root]');
    gallery.querySelectorAll('[data-gallery-button]').forEach((button) => button.addEventListener('click', () => setGallery(root, button.dataset.galleryButton)));
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const dataElement = root.querySelector('[data-product-json]');
    if (!dataElement) return;
    let product;
    try { product = JSON.parse(dataElement.textContent); } catch (_) { return; }
    const form = root.querySelector('.meltie-product-form');
    const variantSelect = root.querySelector('[data-variant-select]');
    const status = root.querySelector('[data-product-status]');
    const currency = root.dataset.currency || 'USD';
    const colorOptionIndex = Number(root.dataset.colorOptionIndex || 0);
    let activeVariant = product.variants.find((variant) => String(variant.id) === String(variantSelect && variantSelect.value)) || product.variants[0];
    let sending = false;

    const updatePrices = () => {
      if (!activeVariant) return;
      const price = activeVariant.price || 0;
      const compare = activeVariant.compare_at_price || 0;
      const hasCompare = compare > price;
      const priceEl = root.querySelector('[data-product-price]');
      const compareEl = root.querySelector('[data-product-compare]');
      const saveEl = root.querySelector('[data-product-save]');
      if (priceEl) priceEl.textContent = money(price, currency);
      if (compareEl) { compareEl.hidden = !hasCompare; compareEl.textContent = money(compare, currency); }
      if (saveEl) { saveEl.hidden = !hasCompare; saveEl.textContent = hasCompare ? `SAVE ${Math.round((compare - price) * 100 / compare)}%` : ''; }
      root.querySelectorAll('[data-bundle-price]').forEach((el) => { el.textContent = money(price * Number(el.dataset.bundlePrice), currency); });
      root.querySelectorAll('[data-bundle-compare]').forEach((el) => { const quantity = Number(el.dataset.bundleCompare); el.hidden = !hasCompare; el.textContent = money(compare * quantity, currency); });
      root.querySelectorAll('[data-bundle-savings]').forEach((el) => { el.textContent = money(Math.max(compare - price, 0) * Number(el.dataset.bundleSavings), currency); });
      root.querySelectorAll('[data-checkout]').forEach((button) => { button.disabled = !activeVariant.available; });
      if (variantSelect) variantSelect.value = activeVariant.id;
      const imageUrl = activeVariant.featured_media && activeVariant.featured_media.preview_image && activeVariant.featured_media.preview_image.src;
      if (imageUrl) {
        const name = imageUrl.split('?')[0].split('/').pop();
        const candidates = [...root.querySelectorAll('[data-gallery-image]')];
        const target = candidates.find((image) => image.currentSrc.includes(name) || image.src.includes(name));
        if (target) setGallery(root, target.dataset.galleryImage);
      }
    };

    const syncVariant = () => {
      const values = [...root.querySelectorAll('[data-option-position]:checked')].sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)).map((input) => input.value);
      const match = product.variants.find((variant) => variant.options && variant.options.every((value, index) => value === values[index]));
      if (match) activeVariant = match;
      root.querySelectorAll('[data-option-position]:checked').forEach((input) => {
        const label = root.querySelector(`[data-option-label="${input.dataset.optionPosition}"]`);
        if (label) label.textContent = `— ${input.value}`;
      });
      const currentColor = activeVariant && activeVariant.options && activeVariant.options[colorOptionIndex];
      if (currentColor) {
        root.querySelectorAll('[data-bundle-color]').forEach((select) => {
          const matchingOption = [...select.options].find((option) => option.value === currentColor && !option.disabled);
          if (!select.dataset.userSelected && matchingOption) select.value = currentColor;
        });
      }
      updatePrices();
    };

    root.querySelectorAll('[data-option-position]').forEach((input) => input.addEventListener('change', syncVariant));
    root.querySelectorAll('[data-bundle-color]').forEach((select) => select.addEventListener('change', () => { select.dataset.userSelected = 'true'; }));
    root.querySelectorAll('[data-bundle]').forEach((input) => input.addEventListener('change', () => {
      root.querySelectorAll('[data-bundle-option]').forEach((option) => option.classList.toggle('is-selected', option.contains(input)));
      root.querySelectorAll('[data-bundle-colors]').forEach((colors) => { colors.hidden = String(colors.dataset.bundleColors) !== input.value; });
    }));

    async function purchase() {
      if (sending || !activeVariant || !activeVariant.available) return;
      sending = true;
      status.textContent = 'Adding to cart…';
      const bundle = Number((root.querySelector('[data-bundle]:checked') || {}).value || 1);
      const selectedBundleOption = root.querySelector(`[data-bundle-option="${bundle}"]`);
      const colors = [];
      for (let number = 1; number <= bundle; number += 1) {
        const select = selectedBundleOption && selectedBundleOption.querySelector(`[data-bundle-color="${number}"]`);
        colors.push(select ? select.value : (activeVariant.options && activeVariant.options[colorOptionIndex]));
      }
      const grouped = new Map();
      const unavailableColors = [];
      colors.forEach((color) => {
        const variant = product.variants.find((item) => item.options && item.options[colorOptionIndex] === color);
        if (!variant || !variant.available) unavailableColors.push(color || 'selected color');
        else grouped.set(String(variant.id), (grouped.get(String(variant.id)) || 0) + 1);
      });
      if (unavailableColors.length) {
        status.textContent = `${[...new Set(unavailableColors)].join(', ')} is sold out. Please choose an available color.`;
        sending = false;
        return;
      }
      const items = [...grouped.entries()].map(([id, quantity]) => ({ id: Number(id), quantity }));
      try {
        const response = await fetch(`${rootPath()}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error('Cart request failed');
        status.textContent = 'Taking you to checkout…';
        window.location.assign(`${rootPath()}checkout`);
      } catch (_) {
        status.textContent = 'Could not add this item. Please try again.';
        sending = false;
      }
    }

    if (form) form.addEventListener('submit', (event) => { event.preventDefault(); purchase(); });
    updatePrices();
  });
})();
